'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValidUrlNoProtocol = exports.isValidUrl = exports._isHostValid = exports._isProtocolValid = undefined;

var _parseUrl2 = require('url-lib/parseUrl');

var _parseUrl3 = _interopRequireDefault(_parseUrl2);

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseUrl = (0, _memoize2.default)(_parseUrl3.default);
var DOMAIN_REGEX = /(.+)\.(.+)/;

var _isProtocolValid = exports._isProtocolValid = function _isProtocolValid(value) {
    return value === 'http:' || value === 'https:';
};
var _isHostValid = exports._isHostValid = function _isHostValid(value) {
    return value.match(DOMAIN_REGEX);
};

var isValidUrl = exports.isValidUrl = function isValidUrl(value) {
    var url = parseUrl(value);

    return Boolean(_isProtocolValid(url.protocol) && url.host && _isHostValid(url.host));
};

var isValidUrlNoProtocol = exports.isValidUrlNoProtocol = function isValidUrlNoProtocol(value) {
    var url = parseUrl(value);

    return Boolean((url.protocol === '' || _isProtocolValid(url.protocol)) && _isHostValid(url.href));
};